import { render, staticRenderFns } from "./ClinicSchedule.vue?vue&type=template&id=efb23fb8"
import script from "./ClinicSchedule.vue?vue&type=script&lang=js"
export * from "./ClinicSchedule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports